export default function (cls) {
  /**
   * 发送站内信
   *
   * @param from_name 发送者姓名
   * @param from_mobile 发送者手机号
   * @param from_content 发送的内容
   * @param to_member_openid 接收者的openid
   * @param to_type 接收主体类型 100=资源主页，200=店铺
   * @param to_id 接收主体ID
   * @param from_mobile_code  国际区号
   * @returns {Promise}
   */
  cls.prototype.siteMsgAdd = async function ({from_name, from_mobile, from_content, to_member_openid, to_type, to_id, from_mobile_code}) {
    const response = await cls.request({
      method: 'post',
      url: '/account/site-msg/add',
      data: {
        from_name,
        from_mobile,
        from_content,
        to_member_openid,
        to_type,
        to_id,
        from_mobile_code
      }
    })
    return response
  }
}



// WEBPACK FOOTER //
// ./src/modules/member/api/siteMsgApi.js